import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getQrCode } from '../../services/api';

class ContentShare extends React.PureComponent {
    static propTypes = {
        shareInfo: PropTypes.object.isRequired,
    };

    static defaultProps = {
        shareInfo: {
            url: '',
            title: '',
            summery: '',
            picUrl: '',
        },
    };

    state = {
        qrCodeShow: false,
    };

    handleClick = e => {
        const { qrCodeShow } = this.state;
        const item = e.currentTarget.attributes['data-item'].value;
        const { url, title, summery, picUrl } = this.props.shareInfo;

        if (item === 'sina') {
            window.open(
                `http://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(
                    title,
                )}&summery=${encodeURIComponent(summery)}&pic=${encodeURIComponent(picUrl)}`,
            );
        } else if (item === 'qqzone') {
            window.open(
                `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                    url,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(picUrl)}`,
            );
        } else if (item === 'wechat') {
            if (this.qrCode) {
                this.setState({
                    qrCodeShow: !qrCodeShow,
                });
            } else {
                this.getQrCode(e.currentTarget);
            }
        }
    };

    getQrCode = async () => {
        const { url } = this.props.shareInfo;

        if (!this.qrCode) {
            const data = await getQrCode(url);

            this.qrCode = data.qrcode_url;
        }

        this.setState({
            qrCodeShow: true,
        });
    };

    handleClose = () => {
        this.setState({
            qrCodeShow: false,
        });
    };

    render() {
        const { qrCodeShow } = this.state;

        return (
            <div className={styles.share_box}>
                <div className={styles.share_bar}>
                    <a className={styles.sina} data-item="sina" onClick={this.handleClick} />
                    <a className={styles.qqzone} data-item="qqzone" onClick={this.handleClick} />
                    <a className={styles.wechat} data-item="wechat" onClick={this.handleClick} />
                </div>
                {qrCodeShow ? (
                    <div className={styles.wexin_share}>
                        <div className={styles.wx}>
                            <div className={styles.qrCode_box}>
                                <img src={this.qrCode} />
                                <p>
                                    用微信扫描二维码<br />分享至好友和朋友圈
                                </p>
                                <div className={styles.close} onClick={this.handleClose} />
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export { ContentShare };
export default ContentShare;
